// extracted by mini-css-extract-plugin
export var pillTrigger = "_5t-0";